
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__moon","width":"16","height":"16","fill":"#fff"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.06 9.73a.31.31 0 00-.13 0 4.52 4.52 0 01-1.43.27 4.54 4.54 0 01-4.32-3.27 4.29 4.29 0 01.06-2.66.4.4 0 00-.37-.53.41.41 0 00-.18 0 5 5 0 001.39 9.33A5.82 5.82 0 008 13a5 5 0 004.41-2.69.4.4 0 00-.35-.58zM8 12a3.81 3.81 0 01-.75-.07A4 4 0 015 5.37 5.73 5.73 0 005.21 7 5.56 5.56 0 009 10.79a5.61 5.61 0 001.5.21h.13A4 4 0 018 12zm6-6.12A1.88 1.88 0 0112.13 4a.12.12 0 00-.13-.12.12.12 0 00-.12.12A1.89 1.89 0 0110 5.88a.12.12 0 00-.12.12.12.12 0 00.12.13A1.88 1.88 0 0111.88 8a.12.12 0 00.12.13.13.13 0 00.13-.13A1.87 1.87 0 0114 6.13a.13.13 0 00.13-.13.12.12 0 00-.13-.12zM7 2.63A1.37 1.37 0 018.38 4a.12.12 0 00.12.13.13.13 0 00.13-.13A1.37 1.37 0 0110 2.63a.13.13 0 00.13-.13.12.12 0 00-.13-.12A1.37 1.37 0 018.63 1 .12.12 0 008.5.88a.12.12 0 00-.12.12A1.38 1.38 0 017 2.38a.12.12 0 00-.12.12.12.12 0 00.12.13z"}})])
          )
        }
      }
    